import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabase";
import BackButton from "../../components/BackButton";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "info", message: "" });

  useEffect(() => {
    // Basic guard: ensure we have a session (recovery link should set it)
    (async () => {
      const { data } = await supabase.auth.getSession();
      if (!data?.session) {
        setStatus({
          type: "error",
          message:
            "الرابط غير صالح أو انتهت صلاحيته. اطلب رابط إعادة تعيين جديد من لوحة Supabase.",
        });
      } else {
        setStatus({ type: "info", message: "أدخل كلمة المرور الجديدة لإكمال التحديث." });
      }
    })();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "info", message: "جاري تحديث كلمة المرور..." });

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setStatus({ type: "error", message: error.message });
      setLoading(false);
      return;
    }

    setStatus({ type: "success", message: "تم تحديث كلمة المرور بنجاح ✅ يمكنك الآن تسجيل الدخول." });
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col items-center p-4 pt-8">
      <div className="w-full max-w-sm flex justify-start mb-4">
        <BackButton to="/" label="الرئيسية" />
      </div>
      <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-4 border rounded-xl p-6 bg-background">
        <h1 className="text-xl font-bold text-center">إعادة تعيين كلمة المرور</h1>

        <p className="text-sm opacity-80 text-center">{status.message}</p>

        <input
          type="password"
          placeholder="كلمة المرور الجديدة"
          className="w-full border rounded px-3 py-2"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={8}
          disabled={loading || status.type === "error"}
        />

        <button
          disabled={loading || status.type === "error"}
          className="w-full bg-black text-white py-2 rounded"
        >
          {loading ? "جاري الحفظ..." : "تحديث كلمة المرور"}
        </button>
      </form>
    </div>
  );
}
